import { AnnotationStatus } from "@faro-lotv/ielement-types";
import { getMarkupsDueDateFilterOptions } from "@pages/project-details/project-markups/project-markups-filters/project-markups-filter-list";
import { getMarkupStatusValue } from "@pages/project-details/project-markups/status/markup-status-utils";
import { currentUserCreatedMarkupsSelector, currentUserMarkupsSelector, markupsSelector } from "@store/markups/markups-selector";

/** Which annotations are summarized: the ones assigned to or created by the current user, or all of them */

/** Options to switch between the summarized annotations */
export const MARKUPS_SUMMARY_SCOPE_OPTIONS = [{
  label: "Assigned to me",
  value: "mine"
}, {
  label: "Created by me",
  value: "created"
}, {
  label: "All annotations",
  value: "all"
}];

/** Selectors of the markups of each scope */
export const MARKUPS_SCOPE_SELECTORS = {
  mine: currentUserMarkupsSelector,
  created: currentUserCreatedMarkupsSelector,
  all: markupsSelector
};

/** IDs of the annotations table due date filters used by the summary */

/** Due date filter that matches the overdue markups */
export const OVERDUE_FILTER_ID = "beforeToday";

/** Due date filter that matches the due soon markups */
export const DUE_SOON_FILTER_ID = "next7Days";

/** Filters of the annotations table that show the markups behind a part of the summary */

/** Amount of markups of a single status */

/** Statuses in the order they are shown in the summary, same as the status order of the annotations table */
export const SUMMARY_STATUSES = [AnnotationStatus.Unclassified, AnnotationStatus.Open, AnnotationStatus.InProgress, AnnotationStatus.ToReview, AnnotationStatus.Resolved];

/** Statuses of the markups that are not resolved, for which the overdue amount is tracked */
export const OVERDUE_TRACKED_STATUSES = [AnnotationStatus.Unclassified, AnnotationStatus.Open, AnnotationStatus.InProgress, AnnotationStatus.ToReview];

/** Returns whether the overdue amount is tracked for the provided status */
export function isOverdueTrackedStatus(status) {
  return OVERDUE_TRACKED_STATUSES.includes(status);
}

/**
 * Returns the amount of markups, overdue and due soon markups for every status.
 * Overdue and due soon use the same due date filters as the annotations table,
 * so the amounts match the table after clicking them.
 */
export function getMarkupsStatusSummary(markups) {
  const dueDateFilters = getMarkupsDueDateFilterOptions();
  const isOverdue = dueDateFilters[OVERDUE_FILTER_ID].hasEntityPassedFilter;
  const isDueSoon = dueDateFilters[DUE_SOON_FILTER_ID].hasEntityPassedFilter;
  const summaries = SUMMARY_STATUSES.map(status => ({
    status,
    count: 0,
    overdueCount: 0,
    dueSoonCount: 0
  }));
  markups.forEach(markup => {
    const status = getMarkupStatusValue(markup.status?.value);
    const summary = summaries.find(item => item.status === status);
    if (!summary) {
      return;
    }
    summary.count++;
    if (!isOverdueTrackedStatus(status)) {
      return;
    }
    if (isOverdue(markup)) {
      summary.overdueCount++;
    } else if (isDueSoon(markup)) {
      summary.dueSoonCount++;
    }
  });
  return summaries;
}